import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from '../router/Link'
import translate from '../../helper/translate'
import { desktop, mobile } from '../../styles/media'
import Icon from '../general/Icon'
import { StyledCollectionName } from '../collection/CollectionName'
import { StyledCoverImage } from '../../pages/deck/components/CoverImage'

const Breadcrumb = ({ children, t }) => (
	<StyledBreadcrumb>
		<BreadcrumbItem home to="/" title={t('general.home')}><Icon name="home" /></BreadcrumbItem>
		<BreadcrumbSeparator>/</BreadcrumbSeparator>
		{children && (Array.isArray(children) ? children : React.Children.toArray(children)).map((child, index) => child ? (
			<Fragment key={index}>
				{child}
				<BreadcrumbSeparator>/</BreadcrumbSeparator>
			</Fragment>
		) : null)}
	</StyledBreadcrumb>
)

Breadcrumb.propTypes = {
	children: PropTypes.any,
	t: PropTypes.func.isRequired
}

Breadcrumb.defaultProps = {
	children: null
}

export const StyledBreadcrumb = styled.div`
	font-size: 0.9rem;

	position: relative;
	left: -0.5rem;
	width: calc(100% + 1rem);

	align-items: center;
	display: flex;

	${desktop`
		margin-bottom: 0.5rem;
	`}

	${mobile`
		top: -0.5rem;

		overflow: auto;
	`}
`

export const BreadcrumbSeparator = styled.div`
	color: ${props => props.theme.backgroundSolid};
	font-weight: bold;
`

export const BreadcrumbItem = styled(Link)`
	color: ${props => props.theme.textLight};
	padding: 0.5rem 0.35rem;
	text-decoration: none;
	white-space: nowrap;

	align-items: center;
	display: flex;
	justify-content: center;

	${props => props.home && `
		width: 32px;
	`}

	> svg {
		height: 16px;
		width: 16px;
	}

	${StyledCollectionName} {
		padding-left: calc(20px + 0.35rem);
		position: relative;

		> div {
			position: absolute;
			left: 0;
		}
	}

	${StyledCoverImage} {
		margin-right: 0.35rem;
	}

	${desktop`
		${props => props.home ? `
			&:hover {
				background: ${props.theme.backgroundLight};
				border-radius: 50%;
				color: ${props.theme.text};
			}
		` : `
			&:hover {
				color: ${props.theme.textLight};
				text-decoration: underline;
			}
		`}
	`}
`

const Right = styled.div`
	margin-left: auto;
	padding-left: 1rem;
`

const enhance = translate('general')

export default enhance(Breadcrumb)
